import { request } from "services/api/util";

class ProductSegmentService {
  async getListProductSegment(param) {
    const config = {
      method: "get",
      url: `admin/productSegment`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ProductSegmentService();
